import { useEffect, useRef } from 'react';
import { SameAsValue } from '../AccidenCreatingStepCustomerInformations';

export const useSameAsHiding = (
  value: SameAsValue | undefined,
  setValue: ((v: SameAsValue) => void) | undefined,
  shouldHideUser: boolean,
  shouldHideOperator: boolean
) => {
  const changedDueToHiding = useRef(false);

  useEffect(() => {
    if (shouldHideUser && value === 'user') {
      changedDueToHiding.current = true;
      setValue?.(shouldHideOperator ? 'none' : 'operator'); // ← optional chaining
      return;
    }

    if (shouldHideOperator && value === 'operator') {
      changedDueToHiding.current = true;
      setValue?.(shouldHideUser ? 'none' : 'user');
      return;
    }

    if (!shouldHideUser && changedDueToHiding.current && value !== 'user') {
      changedDueToHiding.current = false;
      setValue?.('user');
      return;
    }

    if (!shouldHideOperator && changedDueToHiding.current && value !== 'operator') {
      changedDueToHiding.current = false;
      setValue?.('operator');
      return;
    }
  }, [shouldHideUser, shouldHideOperator, value]);
};
